import React from "react";
import { Card } from "react-bootstrap";

/**
 * Module A fixed band -> label mapping (#6): 1 = Needs Support, 2 = Needs
 * Practice, 3 = Ready to Lead. A null band renders the neutral dash "—" (no
 * fabricated number).
 */
const BAND_LABELS = {
  1: "Needs Support",
  2: "Needs Practice",
  3: "Ready to Lead",
};

const NEUTRAL_DASH = "—";

export const bandLabel = (band) => {
  if (band === null || band === undefined) return NEUTRAL_DASH;
  return BAND_LABELS[band] || NEUTRAL_DASH;
};

const TIER_HEADERS = {
  prereq: "Prereq",
  target: "Target",
  extension: "Extension",
};

const MemberRow = ({ member, isMixed }) => {
  const hasBand = member.band !== null && member.band !== undefined;
  return (
    <div className="member-row" data-testid={`member-${member.student_id}`}>
      <span className="member-name">{member.display_name}</span>
      <span className="member-band" data-testid="band-cell">
        {hasBand ? `${member.band} (${bandLabel(member.band)})` : NEUTRAL_DASH}
      </span>
      {isMixed && (
        <span className="member-composition">L{member.composition_level}</span>
      )}
      <span className="member-rationale">{member.rationale}</span>
    </div>
  );
};

/**
 * Render a GroupRecommendationResponse as tier cards, in the engine's emission
 * order (the groups array is already Prereq -> Target -> Extension). Prereq /
 * Extension cards show the routed standard and (when present) the routing
 * message. The composition_level is shown for the mixed strategy.
 */
export const GroupCards = ({ response }) => {
  const groups = response?.groups || [];
  const isMixed = response?.strategy === "mixed_readiness";

  return (
    <div className="group-cards">
      {groups.map((group, i) => (
        <Card
          key={i}
          className="tier-card"
          data-testid={`group-card-${i}`}
          style={{ marginBottom: "16px" }}
        >
          <Card.Body>
            <h3 className="tier-header">{TIER_HEADERS[group.tier] || group.tier}</h3>
            {group.standard && (
              <div className="group-standard">Standard: {group.standard}</div>
            )}
            {group.message && (
              <div className="group-message">{group.message}</div>
            )}
            {group.members.map((member) => (
              <MemberRow
                key={member.student_id}
                member={member}
                isMixed={isMixed}
              />
            ))}
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
